__turbopack_context__.v({
  "Caption": "OuQazG_Caption",
  "ImageWrapper": "OuQazG_ImageWrapper",
  "Root": "OuQazG_Root",
  "skeleton-loading": "OuQazG_skeleton-loading",
});
